__webpack_require__.p = "/wp-content/plugins/votepa-forms-revamp/frontend/build/";